import weekDay from 'dayjs/plugin/weekday';

export default defineNuxtPlugin({
	name: 'dayjs',
	parallel: true,
	setup: () => {
		const dayjs = useDayjs();
		dayjs.extend(weekDay);
	},
});
